import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
require('../css/customDatepicker.css');
import {browserHistory} from 'react-router'
import AlertTimeBook from './components/AlertTimeBook';

class StepTwo extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onBtnClickHandler = this.onBtnClickHandler.bind(this);
        this.inactiveAlertTimeBook = this.inactiveAlertTimeBook.bind(this);
        this.activeAlertTimeBook = this.activeAlertTimeBook.bind(this);
        this.onBtnBack = this.onBtnBack.bind(this);
        this.state = {
            alertTimeBook: false,
            validField: {},
            amountServices: 0,
            startDate: moment(),
            currentDate: moment(),
            userData: {amountPeople: 1},
        }
    }

    componentWillMount() {
        let user = localStorage.getItem('user');
        if (!user) {
            browserHistory.push(`/StepOne`)
        } else {
            let data = {};
            data['datePicker'] = moment().format('YYYY-M-D');
            this.setState({userData: Object.assign({}, this.state.userData, data)});
            data['timepick'] = this.startTime();
            this.setState({userData: Object.assign({}, this.state.userData, data)});
            this.setState({amountServices: this.countService()});
        }
    }

    componentDidMount() {
        let start = moment();

        let remainder = 30 - start.minute() % 30;
        let formatedStart = start.add(remainder, "minutes").add(3, "hours").format("LT");
        let arr = formatedStart.split(' ');
        let hours = arr[0].split(':');

        if ((+hours[0] >= 9 && arr[1] === "PM") || (+hours[0] <= 6 && arr[1] === "AM")) {
            this.setState({startDate: moment().add(1, 'days')});
            this.setState({currentDate: moment().add(1, 'days')});
            this.setState({currentDateFormatted: moment().set({hour: 6, minute:0, second:0, millisecond:0}).format("LT").toUpperCase()});
        } else {
            this.setState({currentDate: start});
            this.setState({currentDateFormatted: formatedStart.toUpperCase()});
        }
    }

    startTime() {
        let start = moment().add(3, "hours");
        let remainder = 30 - start.minute() % 30;

        return moment(start).add(remainder, "minutes").format('LT');
    }

    handleChange(date) {
        this.setState({startDate: date});
    }

    handleInputChange(propName, value) {
        let data = {};
        if (propName === 'datePicker') {
            this.setState({startDate: value});
            value = value.format('YYYY-M-D');
            data[propName] = value;
            this.setState({userData: Object.assign({}, this.state.userData, data)});

            this.setFocusOutAfterSelectedDate(propName);

        } else if (propName === 'timepick') {
            this.activeAlertTimeBook(value.target.value);
            let copyUserData = this.state.userData;
            let dateTime = copyUserData['datePicker'] + ', ' + value.target.value;
            this.setState({userData: {['datePicker']: dateTime}});
            data[propName] = value.target.value;
            this.setState({userData: Object.assign({}, this.state.userData, data)});
        } else {
            data[propName] = value.target.value;
            this.setState({userData: Object.assign({}, this.state.userData, data)});
        }
    }

    setFocusOutAfterSelectedDate(componentType) {
        if (componentType === 'datePicker') {
            let self = this;

            function focusToNextInput(){
                self.refs.selectDate.focus();
            }
            setTimeout(focusToNextInput, 0);
        }
    }

    activeAlertTimeBook(timepick) {
        let minDate = moment();
        let maxDate = moment().add(3, 'hours');
        let dateString = timepick + ' ' + this.state.userData['datePicker'];
        let newDate = moment(dateString, "h:mm a YYYY-MM-DD");

        if (newDate >= minDate && newDate <= maxDate) {
            this.setState({alertTimeBook: true});
        }
    }

    inactiveAlertTimeBook(e) {
        this.setState({alertTimeBook: e});
    }


    countService() {
        let dataServices = JSON.parse(localStorage.getItem('servicesData'));
        // let result = Object.values(dataServices).reduce((a, b) => a + b, 0);
        let values = [];
        for (let s in dataServices) {
            values.push(dataServices[s])
        }
        let result = values.reduce((a, b) => a + b, 0);
        return result
    }

    onBtnBack(e) {
        e.preventDefault();
        browserHistory.push(`/ChooseServices`);
    }

    onBtnClickHandler(e) {
        e.preventDefault();
        if (this.validStepTwo(this.state.userData)) {
            localStorage.removeItem("appointment_details");
            localStorage.setItem('appointment_details', JSON.stringify(this.state.userData));
            browserHistory.push(`/StepThree`)
        }
    }

    validStepTwo(userData) {
        let valid = true;
        let data = {};
        data['datePicker'] = this.validationDatePicker(userData.datePicker);
        data['timepick'] = this.validationTimePick(userData.timepick);
        this.setState({validField: data});

        for (let k in data) {
            if (data[k] != "") {
                this.setState({validField: Object.assign({}, this.state.validField, data)});
                valid = false;
            }
        }
        return valid
    }

    isMoreTimepick(timepick) {
        let nowDate = new Date();
        let newDate = new Date(timepick + this.state.userData['datePicker']);
        let minDate = new Date('6:00 AM' + this.state.userData['datePicker']);
        let maxDate = new Date('9:00 PM' + this.state.userData['datePicker']);
        return nowDate >= newDate || newDate < minDate || newDate > maxDate
    }

    validationTimePick(timepick) {
        this.setState({validField: {'timepick': ''}});
        if (!timepick) {
            return 'empty';
        } else if (this.isMoreTimepick(timepick)) {
            return 'invalid';
        } else {
            return ''
        }
    }

    validationDatePicker(datePicker) {
        this.setState({validField: {'datePicker': ''}});
        if (!datePicker) {
            return 'empty';
        } else if (datePicker === "Invalid date") {
            return 'invalid'
        } else {
            return ''
        }
    }

    render() {
        let startTime = this.state.userData['timepick'];
        let alertTimeBook = this.state.alertTimeBook;
        let validField = this.state.validField;
        let errorMessageDatePicker = '';
        let errorMessageTimePick = '';

        for (let el in validField) {
            if (el === 'datePicker' && validField[el] === 'empty') {
                errorMessageDatePicker = <em id="email-error" class="state-error">Please select a date.</em>
            } else if (el === 'datePicker' && validField[el] === 'invalid') {
                errorMessageDatePicker = <em id="email-error" class="state-error">Please reload page.</em>
            } else if (el === 'timepick' && validField[el] === 'empty') {
                errorMessageTimePick = <em id="email-error" class="state-error">Please select a time.</em>
            } else if (el === 'timepick' && validField[el] === 'invalid') {
                errorMessageTimePick = <em id="email-error" class="state-error">Please enter valid time.</em>
            }
        }

        let templateAmountPeople = [];
        let amountServices = this.state.amountServices;
        for (let i = 1; i <= amountServices; i++) {
            templateAmountPeople.push(<option key={i} value={i}>{i}</option>)
        }

        return (
            <div className="smart-wrap">
                <div className="smart-forms smart-container wrap-2">
                    <div className="form-header header-lite">
                        <h4>Appointment Details</h4>
                    </div>
                    <div className="form-body smart-steps steps-theme-primary">
                        <form method="post" action="#" id="smart-form">
                            <fieldset>
                                <div className="frm-row">
                                    <div className="section colm colm6">
                                        <label for="date" className="field-label">Date <em> * </em> </label>
                                        <label
                                            className={Object.keys(errorMessageDatePicker).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            {/*<input type="text" id="date" name="date" className="gui-input"/>*/}
                                            <DatePicker
                                                id="data-picker-input"
                                                className="gui-input padding j-data-picker-input"
                                                fixedHeight
                                                dateFormat="YYYY/MM/DD"
                                                onFocus="true"
                                                ref="datePicker"
                                                minDate={this.state.currentDate}
                                                selected={this.state.startDate}
                                                onChange={this.handleInputChange.bind(this, 'datePicker')}
                                            />
                                            <span className="field-icon">
                                                <i className="fa fa-calendar"></i>
                                            </span>
                                        </label>
                                        {
                                            errorMessageDatePicker
                                        }
                                    </div>
                                    <div className="section colm colm6">
                                        <label for="timepick" className="field-label">Time <em> * </em> </label>
                                        <label for="timepick"
                                               className={Object.keys(errorMessageTimePick).length > 0 ? 'field select state-error' : 'field select'}>
                                            <select
                                                id="timepick"
                                                name="timepick"
                                                ref="selectDate"
                                                onChange={this.handleInputChange.bind(this, 'timepick')}
                                            >
                                                <option value={this.state.currentDateFormatted}>{this.state.currentDateFormatted}</option>
                                                <option value="6:00 AM">6:00 AM</option>
                                                <option value="6:30 AM">6:30 AM</option>
                                                <option value="7:00 AM">7:00 AM</option>
                                                <option value="7:30 AM">7:30 AM</option>
                                                <option value="8:00 AM">8:00 AM</option>
                                                <option value="8:30 AM">8:30 AM</option>
                                                <option value="9:00 AM">9:00 AM</option>
                                                <option value="9:30 AM">9:30 AM</option>
                                                <option value="10:00 AM">10:00 AM</option>
                                                <option value="10:30 AM">10:30 AM</option>
                                                <option value="11:00 AM">11:00 AM</option>
                                                <option value="11:30 AM">11:30 AM</option>

                                                <option value="12:00 PM">12:00 PM</option>
                                                <option value="12:30 PM">12:30 PM</option>
                                                <option value="1:00 PM">1:00 PM</option>
                                                <option value="1:30 PM">1:30 PM</option>
                                                <option value="2:00 PM">2:00 PM</option>
                                                <option value="2:30 PM">2:30 PM</option>
                                                <option value="3:00 PM">3:00 PM</option>
                                                <option value="3:30 PM">3:30 PM</option>
                                                <option value="4:00 PM">4:00 PM</option>
                                                <option value="4:30 PM">4:30 PM</option>
                                                <option value="5:00 PM">5:00 PM</option>
                                                <option value="5:30 PM">5:30 PM</option>
                                                <option value="6:00 PM">6:00 PM</option>
                                                <option value="6:30 PM">6:30 PM</option>
                                                <option value="7:00 PM">7:00 PM</option>
                                                <option value="7:30 PM">7:30 PM</option>
                                                <option value="8:00 PM">8:00 PM</option>
                                                <option value="8:30 PM">8:30 PM</option>
                                                <option value="9:00 PM">9:00 PM</option>
                                            </select>
                                            <i className="arrow double"></i>
                                        </label>
                                        {
                                            errorMessageTimePick
                                        }
                                    </div>
                                    <div className="section colm colm6">
                                        <label for="timepick" className="field-label">Choose number of
                                            clients.</label>
                                        <label for="timepick"
                                               className='field select'>
                                            <select
                                                id="timepick"
                                                name="amountPeople"
                                                onChange={this.handleInputChange.bind(this, 'amountPeople')}
                                            >
                                                {
                                                    templateAmountPeople
                                                }

                                            </select>
                                            <i className="arrow double"></i>
                                        </label>
                                    </div>
                                </div>
                                <div className="section">
                                    <label for="specialnotes" className="field-label">Special instructions </label>
                                    <label className="field prepend-icon">
                                        <textarea
                                            className="gui-textarea"
                                            name="specialnotes"
                                            placeholder="Preferred stylist, allergies to products, any instructions for your stylist."
                                            onChange={this.handleInputChange.bind(this, 'specialnotes')}
                                        ></textarea>
                                        <span className="field-icon"><i className="fa fa-file-text"></i></span>
                                    </label>
                                </div>
                                <div className="controls">
                                    <div className="sendit">
                                        <button
                                            type="submit"
                                            className="button btn-primary"
                                            onClick={this.onBtnClickHandler}
                                        > CONTINUE
                                        </button>
                                    </div>
                                </div>
                                <div className="text-center backer">
                                    <a
                                        href="#"
                                        className="back"
                                        onClick={this.onBtnBack}
                                    >&larr;  Back</a></div>
                            </fieldset>
                        </form>
                    </div>
                </div>
                {
                    alertTimeBook &&
                    <AlertTimeBook
                        inactiveAlertTimeBook={this.inactiveAlertTimeBook}
                    />
                }
            </div>
        )
    }
}

export
default
StepTwo;



/** WEBPACK FOOTER **
 ** ./src/StepTwo.js
 **/